import type { TOC } from '@ember/component/template-only';
import ModalSubscriptionAccess from 'lumen/components/settings/users/modals/modal-subscription-access';
import type HotelSettingsUsersSubscriptionAccessController from 'lumen/controllers/hotel/settings/users/subscription-access';

interface HotelSettingsUsersSubscriptionAccessSignature {
  Args: {
    controller: HotelSettingsUsersSubscriptionAccessController;
  };
}

const HotelSettingsUsersSubscriptionAccess: TOC<HotelSettingsUsersSubscriptionAccessSignature> =
  <template>
    <ModalSubscriptionAccess
      @isLoading={{@controller.isLoading}}
      @isLoadingMore={{@controller.isLoadingMore}}
      @isOwnUser={{@controller.isOwnUser}}
      @onAddAccess={{@controller.addSubscriptionAccess}}
      @onBulkDelete={{@controller.bulkDelete}}
      @onClose={{@controller.close}}
      @onDelete={{@controller.deleteRelationship}}
      @onLoadMore={{@controller.onLoadMore}}
      @onSave={{@controller.saveChanges}}
      @onSearchChange={{@controller.onSearchChange}}
      @onSortChange={{@controller.onSortChange}}
      @relationships={{@controller.relationships}}
      @searchText={{@controller.searchText}}
      @sorts={{@controller.sorts}}
      @userEmail={{@controller.userEmail}}
      @userId={{@controller.userId}}
    />
  </template>;

export default HotelSettingsUsersSubscriptionAccess;
